import { render, staticRenderFns } from "./SpinnerIcon.vue?vue&type=template&id=dc80497e&scoped=true&"
import script from "./SpinnerIcon.vue?vue&type=script&lang=js&"
export * from "./SpinnerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc80497e",
  null
  
)

export default component.exports